import React, { Fragment, useState } from "react";
import { Carousel, CarouselItem, CarouselIndicators, CarouselCaption, Media, CarouselControl, UncontrolledCarousel } from "reactstrap";
import { Row, Col } from "reactstrap";


const WhatWeDo = () => {

    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const items1 = [
        // {
        //     src: require("../../assets/extra/images/old_age_couple_v700.jpg"),
        //     altText: 'Old Age Couple 1',
        //     header: "Title 1",
        //     caption: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        // },
        // {
        //     src: require("../../assets/extra/images/old_age_couple_v700.jpg"),
        //     altText: 'Old Age Couple 2',
        //     header: "Title 2",
        //     caption: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        // },
        {
            // src: require("../../assets/extra/images/3-1.svg"),
            src: require("../../assets/extra/images/bike.svg"),
            altText: 'Image 1',
            header: "Two wheelers",
            caption: '🛵🔧 Ride worry-free with Europ Assistance! We are market leaders in Two-Wheelers Road side assistance!'       
        },
        {
            src: require("../../assets/extra/images/bot.svg"),
            altText: 'Image 2',
            header: "Mobile Assistance",
            caption: '🤖💬 Need help on the road? We are just a text away! Services through WhatsApp Quick, convenient, and at your fingertips. Your safety, simplified.'
        },
        {
            src: require("../../assets/extra/images/car.svg"),
            altText: 'Image 3',
            header: "Four wheelers",
            caption: '🚗🔧 Drive with confidence! Roadside Assistance Services for Four-Wheelers. Your journey, our priority.'
        },
        {
            src: require("../../assets/extra/images/commercial.svg"),
            altText: 'Image 4',
            header: "Commercial vehicles",
            caption: '🚛🔧 EAI extends its expertise to support the wheels of commerce! RSA for Commercial vehicles.'
        }
    ];


    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === items1.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    }

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? items1.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    }

    const goToIndex = (newIndex) => {
        setActiveIndex(newIndex);
        if (animating) return;
    }



    return (
        <Fragment>
            <div className="pt-3 pb-2">
                <Row>
                    
                        <UncontrolledCarousel items={items1} />

                    <Col xl="1"></Col>
                </Row>
            </div>
        </Fragment>
    );


}


export default WhatWeDo;